import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'

// import firebase from "firebase";
// import 'firebase/firestore'
import {firebaseconfig} from '@/plugins/projectvars.js'; 

var config = firebaseconfig;
  const firebaseApp = firebase.initializeApp(config);
  //firebaseApp.firestore().settings({ timestampsInSnapshots:true })

  const db = firebaseApp.firestore()
  const auth = firebase.auth()
  const str = firebase.storage()
  const fn = firebase.functions()
  const currentUser = auth.currentUser

  export {
    db,
    auth,
     str,
     currentUser,
     firebase,
   // str,
    fn   
  }